import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoNuevoCreta from "../nuevocreta/InfoNuevoCreta";
const Footer = lazy(() => import('../footer/Footer'));
function NuevoCreta() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai Creta, un SUV ideal. Muy seguro gracias a su estructura robusta. Además, alto, amplio y cómodo. Garantiza una conducción placentera y divertida"
        />
        <meta
          name="keywords"
          content="SUV, Hyundai, Hyundai Creta, Creta, seguro, amplio, alto"
        />
        <title>Hyundai Nuevo Creta</title>
      </Helmet>
      <Menu />
      <InfoNuevoCreta />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default NuevoCreta;